import { render, staticRenderFns } from "./rebindTip.vue?vue&type=template&id=c08ad300&scoped=true&"
import script from "./rebindTip.vue?vue&type=script&lang=js&"
export * from "./rebindTip.vue?vue&type=script&lang=js&"
import style0 from "./rebindTip.vue?vue&type=style&index=0&id=c08ad300&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08ad300",
  null
  
)

component.options.__file = "rebindTip.vue"
export default component.exports